<template>
  <div class="home">
    <v-container>
      <Slider />
      <v-card outlined elevation="3" class="giftcode-news">
        <GiftcodeNew />
      </v-card>
      <GameComp />
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Slider from '../components/Slider'
import GameComp from '../components/GameComp'
import GiftcodeNew from '../components/GiftcodeNew'
export default {
  name: 'Home',
  components: { Slider, GameComp, GiftcodeNew },
}
</script>
